module.exports = __webpack_public_path__ + "static/media/prequal.20b8b570.png";